import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const ConsolidationFilter = (props) => {
  const filterOptions = [
    { text: "Consolidated", value: true },
    { text: "Not Consolidated", value: false },
  ];

  const onChange = (event) => {
    const newValue = event.target.value.value;
    props.onChange({
      value: newValue,
      operator: "eq",
      syntheticEvent: event.syntheticEvent,
    });
  };

  const clearFilter = () => {
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: null,
    });
  };

  return (
    <div>
    <DropDownList
      data={filterOptions}
      textField="text"
      dataItemKey="value"
      onChange={onChange}
      value={filterOptions.find((item) => item.value === props.value) || null}
    /> 
    <Button
    icon="close"
    onClick={clearFilter}
    style={{ marginRight: "8px" }}
    title="Clear Filter"
    />
  </div>
  );
};